export let APP_URL = "https://omessage.oapps.xyz/rest";
export let APP_CLIENT_URL = "https://alpha.oapps.xyz/client";
export let APP_REACT_URL = "https://omessage.oapps.xyz";
export let CHARGEBEE_SCRIPT_URL = "https://js.chargebee.com/v2/chargebee.js";
export let COMPANY_NAME = "HelloSend";
export let ASSIST_MAIL = "assist@hellosend.com";
export let ZOHO_CRM_API_VARIABLE_NAME = "ringcentralbulksmsextensionforzohocrm__".trim();
export let ZOHO_CRM_API_VOICE_VARIABLE_NAME = "telnyxsmsforzohocrm__".trim();
export let Chargebee_PLAN_NAME_MONTHLY = "HelloSend-Messaging-USD-Monthly";
export let Chargebee_PLAN_NAME_YEARLY = "HelloSend-Messaging-USD-Yearly";
export let Chargebee_PLAN_NAME_MONTHLY_OLD = "Gold-USD-Monthly";
export let Chargebee_PLAN_NAME_YEARLY_OLD = "Gold-USD-Yearly";
export let Old_Messaging_Chargebee_PLAN_NAME_MONTHLY = "Gold-User-Based-USD-Monthly";
export let Old_Messaging_Chargebee_PLAN_NAME_YEARLY = "Gold-User-Based-USD-Yearly";
export let VOICE_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-USD-Monthly";
export let VOICE_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-USD-Yearly";
export let VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-plus-Messaging-USD-Monthly";
export let VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-plus-Messaging-USD-Yearly";
export let Chargebee_CHARGE_NAME = "Gold-Credits-USD";
export const CHARGEBEE_MESSAGING_CREDIT_TOPUP = Object.freeze({
  ITEM_PRICE_ID: "credit-topup-USD",
  ITEM_ID: "credit-topup",
});
export const CHARGEBEE_CHANNEL_ADDON = Object.freeze({
  ITEM_ID: "Hellosend-Channel-Addon",
  MONTHLY_ITEM_PRICE_ID: "Hellosend-Channel-Addon-USD-Monthly",
  YEARLY_ITEM_PRICE_ID: "Hellosend-Channel-Addon-USD-Yearly",
});
export const HELLOSEND_INCLUDED_CHANNELS = 3;
export const HELLOSEND_INCLUDED_AI_CREDITS = 30;
export let VOICE_PLUS_MESSAGING_STARTS_AT_MONTHLY = "$60";
export let VOICE_PLUS_MESSAGING_MONTHLY_PRICE = "$25";
export let VOICE_PLUS_MESSAGING_YEARLY_PRICE = "$20";
export const urlParams = new URLSearchParams(window.location.search);
export const localStorage = isBrowserSupportsLocalStorage() ? window.localStorage : {};
export const integId = "";
export const osyncId = "";
export const hash = "";
export const osyncUrl = "";
export const clientUrl = "";
export const isOmniAccount = urlParams.get("isOmniAccount");
export const rightServiceId = "";
export const leftServiceId = "";
export const serviceName = "";
export const ZOHODESK = {};
export const CREDIT_BASED_SERVICES = ["hello_send", "teams_helloSend"];
export const STANDALONE_MODE_UTM_SOURCES = ["zohobigin"];
export const WHATSAPP_DISPLAY_NAME = "WhatsApp";
export const WHATSAPP_BETA_DISPLAY_NAME = WHATSAPP_DISPLAY_NAME;
export const FACEBOOK_MESSENGER_SERVICE_NAME = "facebook";
export const INSTAGRAM_MESSENGER_SERVICE_NAME = "instagram";
export const FEED_COMMENT_SENT_VIA_STATUS = "social_feed_comment";
/** Matches {@code MessageSourceEnum.SOCIAL_FEED_COMMENT} sourceValue on inbox / pusher payloads */
export const FEED_COMMENT_SENT_VIA_DISPLAY = "Social Feed Comment";
/** Matches {@code MessageSourceEnum.SOCIAL_FEED_COMMENT} status on inbox / pusher payloads */
export const FEED_COMMENT_CREATED_FROM_STATUS = 19;
export const TWILIO_RCS_DISPLAY_NAME = "RCS";
export const TWILIO_WHATSAPP_DISPLAY_NAME = "Twilio WhatsApp";
export const TELEGRAM_SERVICE_NAME = "telegram";
export const TEAMS_USER_IMPRESSION_SERVICE_ID = "05ef9f6b-750c-4653-a0d5-1e704137b2fb";
export const TEAMS_LEFT_SERVICE_ID = "5943d1af-51e8-426c-8d37-20ca4039fc3e";
export const ALL_TEMPLATE_MODULE_OBJECT = { value: "all", label: "All", dataCy: "all-modules" };
export const PLAIN_TEMPLATE_OBJECT = { value: "hs_::_general", label: "General", dataCy: "general" };
export const HELLOSEND_CALL_APP_INSTALLATION_URL = "/app/crm/call-for-zoho-crm";
export const HELLOSEND_MESSAGE_APP_INSTALLATION_URL = "/app/crm/hellosend-twilio-call-sms-whatsapp-zoho-crm";
export const BOT_NAME = "ZENO";
export const AI_SUGGESTIONS_STATE_KEY = "ai_suggestions_expanded";
export const EXCLUDED_FEATURES = "excludedFeatures";
export const INCLUDED_FEATURES = "includedFeatures";
export const SESSION_STORAGE_KEY_INBOX_PUSH_BANNER_DISMISSED = "hs-push-banner-dismissed";

export const EXCLUDED_FEATURE_IDS = Object.freeze({
  AI_SUGGEST: "ai-suggest",
  VOICE_RECORDING: "voice-recording",
  SELECT_TEMPLATE: "select-template",
  ATTACHMENT: "attachment",
  EMOJI: "emoji",
  NOTES: "notes",
  SCHEDULE_MESSAGE: "schedule-message",
});

const parseCommaSeperatedSettingValueAndConstructSet = (settings, settingName) => {
  const setting = (settings || []).find((s) => s?.settingName_leftServiceId?.includes?.(settingName));
  const value = setting?.settingValue || "";
  return new Set(
    value
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
  );
};

export const parseExcludedFeatureAndConstructSet = (settings) => {
  return parseCommaSeperatedSettingValueAndConstructSet(settings, EXCLUDED_FEATURES);
};
export const parseIncludedFeatureAndConstructSet = (settings) => {
  return parseCommaSeperatedSettingValueAndConstructSet(settings, INCLUDED_FEATURES);
};
export const HELLOSEND_BOOKING_URL = "https://oapps.zohobookings.com/portal-embed#/meeting";
export const TWILIO_CALLER_ID_HELP_URL =
  "https://help.twilio.com/articles/223180048-How-to-Add-and-Remove-a-Verified-Phone-Number-or-Caller-ID-with-Twilio";
export let HS_CRM_API_URL = APP_REACT_URL + "/crm";
export const CRM_ACCESS_DENIED_TITLE = "Access Denied";
export const CSV_IMPORT_MAX_SIZE = 5;
export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
  "text/csv",
];
export const TEMPLATE_TYPE_LABELS = {
  all: "All",
  application: "SMS/WhatsApp",
  whatsapp: "WABA",
  twiliorcs: "RCS",
  twiliowhatsapp: "Twilio WhatsApp",
};
export const TEMPLATE_TYPE_OPTIONS = [
  { label: "SMS/Whatsapp", value: "application", dataCy: "sms-mms-checkbox" },
  { label: "WABA", value: "whatsapp", dataCy: "waba-checkbox" },
  { label: "RCS", value: "twiliorcs", dataCy: "twilio-rcs-checkbox" },
  { label: "Twilio WhatsApp", value: "twiliowhatsapp", dataCy: "twilio-whatsapp-checkbox" },
];

// export const API_VERSION = urlParams.get("version") === "2" ? "v2" : "v1";
export let API_VERSION = "v2";
// if (window.location.pathname.includes("pricing")) {
//   API_VERSION = "v1";
// }
var locationHref = window.location.origin;

// Local-network frontends: a literal 10.10.x.x host (the full /16), octet-validated and anchored.
// Kept in sync with the backend's LocalNetworkUtil pattern so client and server treat the exact
// same subnet as local — a substring check like indexOf("10.10.10") both misses valid hosts
// (10.10.5.x) and matches unintended ones (10.10.100.x).
var LOCAL_NETWORK_HOST_REGEX = /^10\.10\.(25[0-5]|2[0-4]\d|1?\d?\d)\.(25[0-5]|2[0-4]\d|1?\d?\d)$/;
var isLocalNetworkHost = LOCAL_NETWORK_HOST_REGEX.test(window.location.hostname);

export const LicensePlanCategory = {
  GOLD: 1,
  MESSAGE_PLUS_VOICE: 2,
};

export const INCLUDED_FEATURES_IDS = Object.freeze({
  GLOBAL_SEARCH: "global-search",
});

export const AI_ADDON_CREDITS_UI_LABEL = "AI credits";

export const AgentStatusColors = {
  1: "#35c658", // green
  2: "#35c658", // green
  6: "rgb(178, 176, 176)", // grey
  5: "orange", // orange
};
if (locationHref.indexOf("localhost") !== -1) {
  APP_URL = "http://localhost:7000";
  APP_CLIENT_URL = "http://localhost:3000/app";
  APP_REACT_URL = "http://localhost:3001";
  VOICE_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-USD-Monthly";
  VOICE_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-USD-Yearly";
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-plus-Messaging-USD-Monthly";
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-plus-Messaging-USD-Yearly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
  ZOHO_CRM_API_VARIABLE_NAME = "localsetupsms__".trim();
  HS_CRM_API_URL = "http://localhost:8080/crm";
} else if (isLocalNetworkHost) {
    APP_URL = locationHref.replace("3001", "7000");
    APP_CLIENT_URL = locationHref + "/app";
    APP_REACT_URL = locationHref;
    VOICE_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-USD-Monthly";
    VOICE_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-USD-Yearly";
    VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-plus-Messaging-USD-Monthly";
    VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-plus-Messaging-USD-Yearly";
    Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
    ZOHO_CRM_API_VARIABLE_NAME = "localsetupsms__".trim();
    HS_CRM_API_URL = locationHref.replace("3001", "8080") + "/crm";
} else if (
  locationHref.indexOf("staging-osync-client-qa") !== -1 ||
  locationHref.indexOf("pre-alpha.oapps.xyz") !== -1 ||
  locationHref.indexOf("osync-api.oapps.xyz") !== -1
) {
  APP_URL = "https://pre-api.oapps.xyz/rest";
  APP_CLIENT_URL = "http://pre-alpha.oapps.xyz/client";
  APP_REACT_URL = "https://pre-omessage.oapps.xyz";
} else if (
  locationHref.indexOf("staging-client-osync-development-2") !== -1 ||
  locationHref.indexOf("staging-react-client") !== -1 ||
  locationHref.indexOf("mars.rekzyl.com") !== -1
) {
  APP_URL = "https://ganga.rekzyl.com";
  APP_CLIENT_URL = "http://mars.rekzyl.com/client";
} else if (locationHref.indexOf("staging-client-osync-development") !== -1 || locationHref.indexOf("mercury.rekzyl.com") !== -1) {
  APP_URL = "https://ganga.rekzyl.com";
  APP_CLIENT_URL = "http://mercury.rekzyl.com/client";
} else if (locationHref.indexOf("ngrok") !== -1) {
  APP_URL = "https://f7ec-103-204-159-72.ngrok-free.app/rest";
  APP_CLIENT_URL = "https://3165-2401-4900-8825-ac0e-d4cb-59e2-6852-9b39.ngrok-free.app";
  APP_REACT_URL = "https://4615-2401-4900-8825-ac0e-d4cb-59e2-6852-9b39.ngrok-free.app";
  Chargebee_PLAN_NAME_MONTHLY = "Gold-User-Based-USD-Monthly";
  Chargebee_PLAN_NAME_YEARLY = "Gold-User-Based-USD-Yearly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
  HS_CRM_API_URL = "https://server6.rekzyl.com/crm";
} else if (locationHref.indexOf("client3.rekzyl.com") !== -1) {
  APP_URL = "https://server3.rekzyl.com";
  APP_CLIENT_URL = "https://client1.rekzyl.com/client";
  APP_REACT_URL = "https://client3.rekzyl.com";
  Chargebee_PLAN_NAME_MONTHLY = "Gold-User-Based-USD-Monthly";
  Chargebee_PLAN_NAME_YEARLY = "Gold-User-Based-USD-Yearly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
  ZOHO_CRM_API_VARIABLE_NAME = "localsetupsms__".trim();
  HS_CRM_API_URL = "https://server3.rekzyl.com/crm";
} else if (locationHref.indexOf("client4.rekzyl.com") !== -1) {
  APP_URL = "https://client4.rekzyl.com";
  APP_CLIENT_URL = "https://client-qa.rekzyl.com/client";
  APP_REACT_URL = "https://client4.rekzyl.com";
  // Chargebee_PLAN_NAME_MONTHLY = "Gold-User-Based-USD-Monthly";
  // Chargebee_PLAN_NAME_YEARLY = "Gold-User-Based-USD-Yearly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
  ZOHO_CRM_API_VARIABLE_NAME = "stagingsetupqakiruba__".trim();
  HS_CRM_API_URL = "https://server4.rekzyl.com/crm";
} else if (locationHref.indexOf("client2.rekzyl.com") !== -1) {
  APP_URL = "https://server2.rekzyl.com";
  APP_CLIENT_URL = "https://client1.rekzyl.com/client";
  APP_REACT_URL = "https://client2.rekzyl.com";
  // Chargebee_PLAN_NAME_MONTHLY = "Gold-User-Based-USD-Monthly";
  // Chargebee_PLAN_NAME_YEARLY = "Gold-User-Based-USD-Yearly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
  ZOHO_CRM_API_VARIABLE_NAME = "stagingsetupqashanthi__".trim();
  ZOHO_CRM_API_VOICE_VARIABLE_NAME = "twiliocallstaging__".trim();
  HS_CRM_API_URL = "https://server2.rekzyl.com/crm";
} else if (locationHref.indexOf("client5.rekzyl.com") !== -1) {
  APP_URL = "https://server5.rekzyl.com";
  APP_CLIENT_URL = "https://client-qa.rekzyl.com/client";
  APP_REACT_URL = "https://client5.rekzyl.com";
  HS_CRM_API_URL = "https://server5.rekzyl.com/crm";
} else if (locationHref.indexOf("pre-omessage.oapps.xyz") !== -1) {
  APP_URL = "https://pre-api.oapps.xyz/rest";
  APP_CLIENT_URL = "https://pre-alpha.oapps.xyz/client";
  APP_REACT_URL = "https://pre-omessage.oapps.xyz";
  Chargebee_PLAN_NAME_MONTHLY = "Gold-USD-Monthly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
} else if (locationHref.indexOf("client2.rekzyl.com") !== -1) {
  APP_URL = "https://server2.rekzyl.com";
  APP_CLIENT_URL = "https://client1.rekzyl.com/client";
  APP_REACT_URL = "https://client2.rekzyl.com";
  HS_CRM_API_URL = "https://server2.rekzyl.com/crm";
} else if (locationHref.indexOf("client6.rekzyl.com") !== -1) {
  APP_URL = "https://server6.rekzyl.com";
  APP_CLIENT_URL = "https://client1.rekzyl.com/client";
  APP_REACT_URL = "https://client6.rekzyl.com";
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY = "Hellosend-Voice-plus-Messaging-USD-Monthly";
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY = "Hellosend-Voice-plus-Messaging-USD-Yearly";
  // Chargebee_PLAN_NAME_MONTHLY = "Gold-USD-Monthly";
  Chargebee_CHARGE_NAME = "staging-gold-credits-USD";
  HS_CRM_API_URL = "https://server6.rekzyl.com/crm";
} else if (locationHref.indexOf("client1.rekzyl.com") !== -1) {
  APP_URL = "https://server1.rekzyl.com";
  APP_CLIENT_URL = "https://client1.rekzyl.com/client";
  APP_REACT_URL = "https://client1.rekzyl.com";
  HS_CRM_API_URL = "https://server1.rekzyl.com/crm";
}

export const countries = [
  { label: "Afghanistan", value: "AF" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "American Samoa", value: "AS" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Anguilla", value: "AI" },
  { label: "Antarctica", value: "AQ" },
  { label: "Antigua & Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Aruba", value: "AW" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahamas", value: "BS" },
  { label: "Bahrain", value: "BH" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bermuda", value: "BM" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia", value: "BO" },
  { label: "Bosnia & Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Bouvet Island", value: "BV" },
  { label: "Brazil", value: "BR" },
  { label: "British Indian Ocean Territory", value: "IO" },
  { label: "British Virgin Islands", value: "VG" },
  { label: "Brunei", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Cape Verde", value: "CV" },
  { label: "Caribbean Netherlands", value: "BQ" },
  { label: "Cayman Islands", value: "KY" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Christmas Island", value: "CX" },
  { label: "Cocos (Keeling) Islands", value: "CC" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo - Brazzaville", value: "CG" },
  { label: "Congo - Kinshasa", value: "CD" },
  { label: "Cook Islands", value: "CK" },
  { label: "Costa Rica", value: "CR" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Curaçao", value: "CW" },
  { label: "Cyprus", value: "CY" },
  { label: "Czechia", value: "CZ" },
  { label: "Côte d\u2019Ivoire", value: "CI" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Eswatini", value: "SZ" },
  { label: "Ethiopia", value: "ET" },
  { label: "Falkland Islands", value: "FK" },
  { label: "Faroe Islands", value: "FO" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "French Guiana", value: "GF" },
  { label: "French Polynesia", value: "PF" },
  { label: "French Southern Territories", value: "TF" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Gibraltar", value: "GI" },
  { label: "Greece", value: "GR" },
  { label: "Greenland", value: "GL" },
  { label: "Grenada", value: "GD" },
  { label: "Guadeloupe", value: "GP" },
  { label: "Guam", value: "GU" },
  { label: "Guatemala", value: "GT" },
  { label: "Guernsey", value: "GG" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Heard & McDonald Islands", value: "HM" },
  { label: "Honduras", value: "HN" },
  { label: "Hong Kong SAR China", value: "HK" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Isle of Man", value: "IM" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jersey", value: "JE" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Laos", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Macao SAR China", value: "MO" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Martinique", value: "MQ" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mayotte", value: "YT" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia", value: "FM" },
  { label: "Moldova", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Montserrat", value: "MS" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar (Burma)", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "New Caledonia", value: "NC" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "Niue", value: "NU" },
  { label: "Norfolk Island", value: "NF" },
  { label: "North Korea", value: "KP" },
  { label: "North Macedonia", value: "MK" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestinian Territories", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Pitcairn Islands", value: "PN" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Qatar", value: "QA" },
  { label: "Romania", value: "RO" },
  { label: "Russia", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Réunion", value: "RE" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Sint Maarten", value: "SX" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Georgia & South Sandwich Islands", value: "GS" },
  { label: "South Korea", value: "KR" },
  { label: "South Sudan", value: "SS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "St. Barthélemy", value: "BL" },
  { label: "St. Helena", value: "SH" },
  { label: "St. Kitts & Nevis", value: "KN" },
  { label: "St. Lucia", value: "LC" },
  { label: "St. Martin", value: "MF" },
  { label: "St. Pierre & Miquelon", value: "PM" },
  { label: "St. Vincent & Grenadines", value: "VC" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Svalbard & Jan Mayen", value: "SJ" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syria", value: "SY" },
  { label: "São Tomé & Príncipe", value: "ST" },
  { label: "Taiwan", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tokelau", value: "TK" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad & Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Turks & Caicos Islands", value: "TC" },
  { label: "Tuvalu", value: "TV" },
  { label: "US Outlying Islands", value: "UM" },
  { label: "US Virgin Islands", value: "VI" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Vatican City", value: "VA" },
  { label: "Venezuela", value: "VE" },
  { label: "Vietnam", value: "VN" },
  { label: "Wallis & Futuna", value: "WF" },
  { label: "Western Sahara", value: "EH" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
  { label: "Åland Islands", value: "AX" },
];

export const languages = [
  {
    value: "Afrikaans",
    label: "Afrikaans",
  },
  {
    value: "Albanian",
    label: "Albanian",
  },
  {
    value: "Arabic",
    label: "Arabic",
  },
  {
    value: "Armenian",
    label: "Armenian",
  },
  {
    value: "Basque",
    label: "Basque",
  },
  {
    value: "Bengali",
    label: "Bengali",
  },
  {
    value: "Bulgarian",
    label: "Bulgarian",
  },
  {
    value: "Catalan",
    label: "Catalan",
  },
  {
    value: "Cambodian",
    label: "Cambodian",
  },
  {
    value: "Chinese (Mandarin)",
    label: "Chinese (Mandarin)",
  },
  {
    value: "Croatian",
    label: "Croatian",
  },
  {
    value: "Czech",
    label: "Czech",
  },
  {
    value: "Danish",
    label: "Danish",
  },
  {
    value: "Dutch",
    label: "Dutch",
  },
  {
    value: "English",
    label: "English",
  },
  {
    value: "Estonian",
    label: "Estonian",
  },
  {
    value: "Fiji",
    label: "Fiji",
  },
  {
    value: "Finnish",
    label: "Finnish",
  },
  {
    value: "French",
    label: "French",
  },
  {
    value: "Georgian",
    label: "Georgian",
  },
  {
    value: "German",
    label: "German",
  },
  {
    value: "Greek",
    label: "Greek",
  },
  {
    value: "Gujarati",
    label: "Gujarati",
  },
  {
    value: "Hebrew",
    label: "Hebrew",
  },
  {
    value: "Hindi",
    label: "Hindi",
  },
  {
    value: "Hungarian",
    label: "Hungarian",
  },
  {
    value: "Icelandic",
    label: "Icelandic",
  },
  {
    value: "Indonesian",
    label: "Indonesian",
  },
  {
    value: "Irish",
    label: "Irish",
  },
  {
    value: "Italian",
    label: "Italian",
  },
  {
    value: "Japanese",
    label: "Japanese",
  },
  {
    value: "Javanese",
    label: "Javanese",
  },
  {
    value: "Korean",
    label: "Korean",
  },
  {
    value: "Latin",
    label: "Latin",
  },
  {
    value: "Latvian",
    label: "Latvian",
  },
  {
    value: "Lithuanian",
    label: "Lithuanian",
  },
  {
    value: "Macedonian",
    label: "Macedonian",
  },
  {
    value: "Malay",
    label: "Malay",
  },
  {
    value: "Malayalam",
    label: "Malayalam",
  },
  {
    value: "Maltese",
    label: "Maltese",
  },
  {
    value: "Maori",
    label: "Maori",
  },
  {
    value: "Marathi",
    label: "Marathi",
  },
  {
    value: "Mongolian",
    label: "Mongolian",
  },
  {
    value: "Nepali",
    label: "Nepali",
  },
  {
    value: "Norwegian",
    label: "Norwegian",
  },
  {
    value: "Persian",
    label: "Persian",
  },
  {
    value: "Polish",
    label: "Polish",
  },
  {
    value: "Portuguese",
    label: "Portuguese",
  },
  {
    value: "Punjabi",
    label: "Punjabi",
  },
  {
    value: "Quechua",
    label: "Quechua",
  },
  {
    value: "Romanian",
    label: "Romanian",
  },
  {
    value: "Russian",
    label: "Russian",
  },
  {
    value: "Samoan",
    label: "Samoan",
  },
  {
    value: "Serbian",
    label: "Serbian",
  },
  {
    value: "Slovak",
    label: "Slovak",
  },
  {
    value: "Slovenian",
    label: "Slovenian",
  },
  {
    value: "Spanish",
    label: "Spanish",
  },
  {
    value: "Swahili",
    label: "Swahili",
  },
  {
    value: "Swedish ",
    label: "Swedish ",
  },
  {
    value: "Tamil",
    label: "Tamil",
  },
  {
    value: "Tatar",
    label: "Tatar",
  },
  {
    value: "Telugu",
    label: "Telugu",
  },
  {
    value: "Thai",
    label: "Thai",
  },
  {
    value: "Tibetan",
    label: "Tibetan",
  },
  {
    value: "Tonga",
    label: "Tonga",
  },
  {
    value: "Turkish",
    label: "Turkish",
  },
  {
    value: "Ukrainian",
    label: "Ukrainian",
  },
  {
    value: "Urdu",
    label: "Urdu",
  },
  {
    value: "Uzbek",
    label: "Uzbek",
  },
  {
    value: "Vietnamese",
    label: "Vietnamese",
  },
  {
    value: "Welsh",
    label: "Welsh",
  },
  {
    value: "Xhosa",
    label: "Xhosa",
  },
];

function isBrowserSupportsLocalStorage() {
  try {
    return "localStorage" in window && window["localStorage"] !== null;
  } catch (e) {
    return false;
  }
}

/**
 * Default inbox tab filters. Keys match hs-inbox-view query param.
 * disabledFilters: field tabDisabledKeys to hide (must match filterFieldConfig).
 * readStatus: when "unread", sets selectedReadStatus for unread tab.
 * needsCurrentUserAssignees: when true, assignees is derived as [currentUser] at runtime.
 */
export const INBOX_DEFAULT_FILTERS = {
    all: {
        value: "all",
        disabledFilters: [],
    },
    unread: {
        value: "unread",
        disabledFilters: ["status", "readStatus"],
        readStatus: "unread",
    },
    "my-open": {
        value: "my-open",
        disabledFilters: ["status", "assignees"],
        needsCurrentUserAssignees: true,
    },
    "my-assigned": {
        value: "my-open",
        disabledFilters: ["status", "assignees"],
        needsCurrentUserAssignees: true,
    },
};

/** Valid hs-inbox-view query param values (filter keys). */
export const INBOX_DEFAULT_FILTERS_VALUES = Object.keys(INBOX_DEFAULT_FILTERS);

/** Pixel size for conversation media thumbnails in the inbox contact panel list. */
export const CONVERSATION_MEDIA_THUMBNAIL_SIZE_PX = 48;

export const NOTIFICATION_PERMISSION_STATUS = {
  GRANTED: "granted",
  DENIED: "denied",
  DEFAULT: "default",
  UNSUPPORTED: "unsupported",
};
